(ns dre.modals.views
  (:require
   [applied-science.js-interop :as j]
   [dre.components.backdrop :refer [backdrop]]
   [dre.components.error-view :refer [error-view]]
   [dre.components.icon :refer [svg]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.i18n.events :as-alias i18n]
   [dre.i18n.views :refer [tr]]
   [dre.modals.db :as db]
   [dre.modals.events :as-alias modals]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))


(def component-name :modal)


(defn- handle-keypress
  [ev]
  (if (= (j/get ev :key) "Escape")
    (rf/dispatch [::modals/clear])
    true))


(defn dismiss-button
  [close-fx]
  [tooltip-wrapper "Dismiss"
   [:a {:class [(bem/bm :button :bare)
                (bem/be component-name :dismiss-button)]
        :href "#"
        :on-click #(do 
                     (when close-fx
                       (rf/dispatch [close-fx]))
                     (rf/dispatch [::modals/clear]))}
    [svg :common :dismiss]]])


(defn base-modal
  []
  (let [error (r/atom nil)]
    (r/create-class
      {:display-name "base-modal"

       :component-did-mount
       #(doto js/window
          (.addEventListener "keydown" handle-keypress))

       :component-will-unmount
       #(doto js/window
          (.removeEventListener "keydown" handle-keypress))

       :component-did-catch
       (fn [_this e _info]
         (js/console.log e))  ; TODO: Notify Sentry

       :get-derived-state-from-error
       (fn [e]
         (reset! error e)
         #js {})

       :reagent-render
       (fn [modal]
         (when modal
           [backdrop
            [:div
             {:class (bem/bm component-name (:id modal))}
             [dismiss-button (:close-fx modal)]
             [:div
              {:class (bem/be component-name :content)}
              (if-let [err @error]
                [error-view (str err)]
                [(:view modal)])]]
            {:on-outside-click (fn [e]
                                 (when (:close-fx modal)
                                   (rf/dispatch [(:close-fx modal)]))
                                 (rf/dispatch [::modals/clear]))}]))})))


(defn view
  "Base component for all modals"
  []
  (let [modal-id @(rf/subscribe [::modals/current-modal-id])
        modal (get db/index modal-id)]
    [base-modal modal]))
